import { render } from "./UserGroupUpdate.vue?vue&type=template&id=c8085462"
import script from "./UserGroupUpdate.vue?vue&type=script&lang=js"
export * from "./UserGroupUpdate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__